"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEtapaPorData = void 0;
const date_fns_1 = require("date-fns");
const filtro_treeview_1 = require("./filtro-treeview");
const getEtapaPorData = ({ etapas, data, idTurma, cursos, }) => {
    const dData = typeof data == 'string' ? (0, date_fns_1.parseISO)(data) : data;
    const turma = (0, filtro_treeview_1.getTurmasTreeView)({ cursos }).find((f) => f.id == idTurma);
    if (!turma || !turma.idCurso)
        return;
    const etapa = etapas.find((f) => {
        var _a, _b, _c;
        return ((_a = f.idsCursos) === null || _a === void 0 ? void 0 : _a.includes((_b = turma.idCurso) !== null && _b !== void 0 ? _b : 0)) &&
            (0, date_fns_1.parseISO)((_c = f.dataEtapaIni) !== null && _c !== void 0 ? _c : '') < dData &&
            (0, date_fns_1.parseISO)(f.dataEtapaFim ? f.dataEtapaFim + ' 23:59:59' : '') >= dData;
    });
    return etapa;
};
exports.getEtapaPorData = getEtapaPorData;
